import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { uploadImage } from '@/utils/firebaseImageUploader.js';
import 'bootstrap/dist/css/bootstrap.min.css'
import './registerServiceWorker'

const app = createApp(App);
app.use(router);
app.config.globalProperties.$useUploadImager = uploadImage;

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

app.mount('#app');
